import defaultAva from '@/components/img/default_ava.jpg';

export interface NotificationSettings {
  enable: boolean;
  regularity: 'timely' | string;
}

export interface DefaultProfileSettings {
  avatar: string;
  notifications: {
    comments: NotificationSettings;
    entries: NotificationSettings;
    messages: NotificationSettings;
    mentions: NotificationSettings;
  };
  currentDesign: string;
  quickAccessLink: { enable: boolean; name: string; url: string };
  privacy: { dybrfeed: boolean };
  feed: { hide: { profiles: string[]; tags: string[] } };
  pinnedEntries: string[];
}

const defaultProfileSettings: DefaultProfileSettings = {
  avatar: defaultAva,
  notifications: {
    comments: {
      enable: true,
      regularity: 'timely'
    },
    entries: {
      enable: true,
      regularity: 'timely'
    },
    messages: {
      enable: true,
      regularity: 'timely'
    },
    mentions: {
      enable: true,
      regularity: 'timely'
    }
  },
  bannedComments: {
    show: false
  },
  autocutLength: 300,
  currentDesign: '0',
  quickAccessLink: { enable: true, name: 'общая лента', url: 'feed' },
  privacy: {
    dybrfeed: true
  },
  feed: { hide: { profiles: [], tags: [] } },
  pinnedEntries: []
};

export default defaultProfileSettings;
